import { WageFrequency } from "@api/shared-runtime/enums";
import { formatCurrency } from "./format-currency";
import { wageFrequencyToEnding } from "@/features/job-offer/utils/wage-frequency-to-ending";

export function getSalaryRange(job: {
  wageMinAmount?: string | null;
  wageMaxAmount?: string | null;
  wageFrequencyId?: WageFrequency | null;
}) {
  const ending = job.wageFrequencyId
    ? (wageFrequencyToEnding[job.wageFrequencyId] ?? "")
    : "";
  const salaryMinNumber = Number(job.wageMinAmount);
  const salaryMaxNumber = Number(job.wageMaxAmount);
  if (
    salaryMinNumber &&
    salaryMaxNumber &&
    salaryMinNumber !== salaryMaxNumber
  ) {
    return `${formatCurrency(salaryMinNumber)}-${formatCurrency(salaryMaxNumber)}${ending}`;
  } else if (salaryMinNumber) {
    return `${formatCurrency(salaryMinNumber)}${ending}`;
  } else if (salaryMaxNumber) {
    return `${formatCurrency(salaryMaxNumber)}${ending}`;
  }
  return "";
}
